module.exports = __webpack_public_path__ + "static/img/active5.c1b5eb1e.png";